module.exports = __webpack_public_path__ + "img/Notification.2ce01769.svg";